<template>
  <div class="container-fluid py-2">
    <div class="p-4 bg-white rounded shadow mb-5">

      <ul id="myTab"
          class="nav nav-tabs nav-pills nav-justified red flex-column
          flex-sm-row text-center bg-light border-0 rounded-nav
          mb-3
          "
          role="tablist">
        <li v-for="issue in circular_issues" :key="issue.id" class="nav-item flex-sm-fill">
          <a :id="issue.name" :class="{'active':issue.id===selected_circular_issue.id}" aria-controls="contact"
             aria-selected="false"
             class="nav-link border-0 text-uppercase font-weight-bolder home-main-tab "
             data-toggle="tab"
             role="tab" style="font-size: 14px;  cursor: pointer"
             @click="changeCircularIssue(issue)">
            {{ issue.name }}
          </a>
        </li>

        <li class="nav-item flex-sm-fill">
          <template v-if="circular_issues_archive[archiveIndexPosition]">
            <a aria-controls="contact"
               aria-selected="false"
               class="nav-link border-0 text-uppercase font-weight-bolder home-main-tab"
               :class="{'active':circular_issues_archive[archiveIndexPosition].id===selected_circular_issue.id}"
               data-toggle="tab"
               @click="changeCircularIssueArchive(circular_issues_archive[0])"
               role="tab" style="font-size: 14px;  cursor: pointer">
              ARCHIVE
            </a>
          </template>

        </li>
      </ul>

      <div class="form-inline d-flex justify-content-center" v-if="showArchiveNavTab">

        <div class="form-group mb-4 mt-2 mr-3" v-for="issue in circular_issues_archive" :key="issue.id">
          <button type="button"
                  class="btn btn-outline-dark"
                  :id="issue.name"
                  :class="{'active':issue.id===selected_circular_issue.id}"
                  @click="changeCircularIssueArchive(issue)"
          >
            {{ issue.name }}
          </button>
        </div>

      </div>


      <!--      <ul id="myTab2"-->
      <!--          class="nav nav-tabs nav-pills nav-justified red flex-column-->
      <!--          flex-sm-row text-center bg-light border-0 rounded-nav-->
      <!--          mb-3-->
      <!--          "-->
      <!--          v-if="showArchiveNavTab"-->
      <!--          role="tablist">-->
      <!--        <li v-for="issue in circular_issues_archive" :key="issue.id" class="nav-item flex-sm-fill">-->
      <!--          <template v-if="issue.is_archive == true">-->
      <!--            <a :id="issue.name" :class="{'active':issue.id===selected_circular_issue.id}" aria-controls="contact"-->
      <!--               aria-selected="false"-->
      <!--               class="nav-link border-0 text-uppercase font-weight-bolder home-main-tab "-->
      <!--               data-toggle="tab"-->
      <!--               role="tab" style="font-size: 14px;  cursor: pointer"-->
      <!--               @click="changeCircularIssueArchive(issue)">-->
      <!--              {{ issue.name }}-->
      <!--            </a>-->
      <!--          </template>-->

      <!--        </li>-->
      <!--      </ul>-->


      <!--      <h1> {{ circular_issues }}</h1>-->

      <div v-if="circular_categories.length > 1" class="navbar-expand-lg navbar-light mb-2">

        <ul class="nav nav-tabs nav-pills nav-justified flex-column
          flex-sm-row text-center bg-light border-0 rounded-nav
          mb-3">

          <tree-nav v-for="nodes in circular_categories" :key="nodes.id" :nodes="nodes"
                    :selected="circularCategory" @menuClick="setCircularCategorySearch"/>
        </ul>

      </div>

      <div class="row mt-5">
        <div class="col">
          <div class="row">
            <div class="form-inline mb-3">
              <div class="form-group mb-2 mr-5">
                <div>
                  <h3 class="text-center ml-4">
                  <span class="badge badge-pill badge-warning mb-2 font-weight-bolder">
                   {{ selected_circular_issue.name }}
                    <br>
                    {{ selectedCategory.name ? `${selectedCategory.name}` : '' }}
                  </span>
                  </h3>
                </div>
              </div>


            </div>

            <!--              <div class="col-3">-->
            <!--                <h4>Courses</h4>-->
            <!--              </div>-->
            <!--              <div class="col-3">-->
            <!--                <button class="btn btn-sm pmc-btn-tertia"-->
            <!--                        data-toggle="modal"-->
            <!--                        data-target="#newCourseModal"-->
            <!--                        data-backdrop="static"-->
            <!--                        data-keyboard="false">-->
            <!--                  <font-awesome-icon icon="user-plus"/>-->
            <!--                  <span>Add</span>-->
            <!--                </button>-->
            <!--              </div>-->


          </div>
        </div>


        <div class="col">
          <div class="form-inline">
            <div class="form-group mr-5">
              <div class="input-group ml-2 mb-3">

                <label for="search" class="input-group-prepend input-group-text form-control-xs bg-white border-0">Search
                  By:</label>
                <div>
                  <select name="search" id="searchKey" class="form-control form-control-xs left-rounded"
                          v-model="searchBySelection"
                  >
                    <option value="attachment">Attachment</option>
                    <option value="subject">Subject</option>
                    <option value="letter_number">Letter Number</option>
                  </select>
                </div>

                <input type="text" id="search-value"
                       class="form-control form-control-xs"
                       aria-describedby="basic-addon2"
                       placeholder="Search attachment"
                       @keypress.enter="show_circular_attachments_modal"
                       v-model="searchValue"
                       v-if="searchBySelection === 'attachment'"
                >

                <input type="text" id="searchSubject"
                       style="width: 250px;"
                       class="form-control form-control-xs"
                       aria-describedby="basic-addon2"
                       placeholder="Search subject"
                       v-model="searchParams.search"
                       v-if="searchBySelection === 'subject'"
                >

                <input type="text" id="searchSubject"
                  style="width: 250px;"
                  class="form-control form-control-xs"
                  aria-describedby="basic-addon2"
                  placeholder="Search Letter Number"
                  v-model="searchParams.letter_number"
                  v-if="searchBySelection === 'letter_number'"
                >

                <div class="input-group-append">
                  <button type="button" class="input-group-text input-group-append"
                          id="btn-search"
                          v-if="searchBySelection === 'attachment'"
                          data-toggle="modal"
                          data-target="#searchCircularAttachmentModal"
                          data-backdrop="static"
                          v-on:click="show_circular_attachments_modal"
                  >
                    <font-awesome-icon icon="search" style="color:#007bff"/>
                  </button>
                  <button v-else id="searchSubjectButton" class="input-group-text input-group-append" type="submit">
                    <font-awesome-icon icon="search" style="color:#007bff"/>
                  </button>
                </div>

              </div>


              <!--              <div class="input-group ml-2 mb-3">-->
              <!--                <label for="search" class="input-group-prepend input-group-text form-control-xs bg-white border-0">Filter SMS:</label>-->
              <!--                -->
              <!--                <select name="search" id="searchKey" class="form-control form-control-xs left-rounded" v-model="searchParams.search">-->
              <!--                  <option :value="letter.name" v-for="letter in smsLetter">{{ letter.letter }}</option>-->
              <!--                </select>-->
              <!--              </div>-->

            </div>

          </div>

        </div>

        <div class="col-md-4">
          <div class="text-right">
            <button v-show="isStaff && (isPrincipalStaff || isPrincipal ||isPrincipalAdmin || isSystemAdmin)"
                    class="btn btn-dark font-weight-bolder"
                    data-target="#upload-modal"
                    data-toggle="modal"
                    type="button">
              <font-awesome-icon icon="upload"></font-awesome-icon>
              UPLOAD
            </button>
            <template v-if="selected_circular_issue.name === 'SMS MANUAL & PROCEDURE'">
              <button class="btn btn-primary" @click="downloadAll" :disabled="isDownloading">
                <template v-if="!isDownloading">
                  <font-awesome-icon icon="angles-down"></font-awesome-icon>
                  Download All
                </template>
                <template v-else>
                  <div class="spinner-border spinner-grow-sm" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                  Downloading
                </template>
              </button>
            </template>
          </div>
        </div>


        <!--        <div class="col-md-4">-->
        <!--          <div class="form-inline">-->
        <!--            <div class="form-group mr-3 mb-4">-->
        <!--              <span class="ml-4 font-weight-bold lead" style="font-size: 15px;">Search by Subject: </span>-->
        <!--            </div>-->

        <!--            <div class="input-group mb-4 border rounded-pill p-1 col-5 bg">-->
        <!--              <input v-model="searchParams.search" aria-describedby="button-addon3"-->
        <!--                     class="form-control ml-1 bg-none border-0 col-9"-->
        <!--                     placeholder="Search .. "-->
        <!--                     type="search">-->
        <!--              <div class="input-group-append border-0">-->
        <!--                <button id="button-addon3" class="btn btn-link text-primary" type="button">-->
        <!--                  <font-awesome-icon icon="search"/>-->
        <!--                </button>-->
        <!--              </div>-->
        <!--            </div>-->

        <!--          </div>-->
        <!--        </div>-->


      </div>

<!--      <div class="form-group mb-2 mr-5">-->
<!--        <div class="input-group ml-2 mb-3" v-if="selected_circular_issue.id == 4">-->
<!--          <label for="search" class="input-group-prepend input-group-text form-control-xs bg-white border-0">Filter-->
<!--            SMS:</label>-->

<!--          <select class="form-control form-control-xs left-rounded" v-model="searchParams.filterSubj">-->
<!--            <option :value="subjects" v-for="(subjects,index) in circularSubjects">{{ subjects }}</option>-->
<!--          </select>-->

<!--        </div>-->
<!--      </div>-->

      <div class="row" v-if="selected_circular_issue.id == 4">
        <div class="col-4">
          <div class="input-group ml-2 mb-3">
            <label for="search" class="input-group-prepend input-group-text form-control-xs bg-white border-0">Filter
              SMS:</label>

            <select class="form-control form-control-xs left-rounded" v-model="searchParams.filterSubj">
              <option value="">ALL</option>-->
              <option :value="subjects" v-for="(subjects,index) in circularSubjects">{{ subjects }}</option>
            </select>

          </div>
        </div>
      </div>


      <div class="modal fade" id="searchCircularAttachmentModal" tabindex="-1" role="dialog"
           aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">

              <div class="form-group row">
                <div class="form-inline">
                  <div class="form-group mr-3">
                    <span class="ml-3 font-weight-bold lead" style="font-size: 15px;">Search result for:</span>
                  </div>
                  <div class="form-group ">
                    <span class="lead" style="font-size: 15px;"><u>{{ searchingFor }}</u></span>
                  </div>
                </div>
              </div>

              <!--              <h6>Search result for: </h6> <span class="ml-4 bg-success">{{ searchingFor }}</span>-->
              <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                      @click="reset_search_circular_attachment">
                <span aria-hidden="true"><h5>x</h5></span>
              </button>
            </div>
            <div class="modal-body addScroll">
              <table class="table" style="font-size: 14px;">
                <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Attachment</th>
                  <th scope="col">Category</th>
                </tr>
                </thead>

                <tbody v-if="isLoading">
                <tr>
                  <td colspan="100%">
                    <base-loader></base-loader>
                  </td>
                </tr>
                </tbody>

                <tbody>
                <tr v-for="(attachment,index) in circularAttachments" :key="attachment.id">
                  <th scope="row">{{ index + 1 }}</th>
                  <!--                  <td>{{ attachment.attachment_name }}</td>-->
                  <td>
                    <button
                        v-if="attachment.hasAttachment"
                        id="circularAttachmentFile"
                        aria-expanded="false"
                        aria-haspopup="true"
                        class="btn badge badge-danger"
                        data-toggle="dropdown"
                        style="font-size:13px;"
                        @click="viewAttachmentFileOnSearch(attachment.circular_id, attachment.id)"
                    >
                      <font-awesome-icon class="mr-2" icon="file-pdf"></font-awesome-icon>
                      {{ attachment.attachment_name }}
                    </button>

                    <button
                        v-if="!attachment.hasAttachment"
                        id="circularAttachmentFile"
                        aria-expanded="false"
                        aria-haspopup="true"
                        class="btn badge badge-danger"
                        style="font-size:13px;"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="No File"
                        disabled
                    >
                      <font-awesome-icon class="mr-2" icon="file-pdf"></font-awesome-icon>
                      {{ attachment.attachment_name }}
                    </button>


                  </td>
                  <td>{{ attachment.circular_category_name }}</td>
                </tr>
                </tbody>
              </table>

              <div class="row">
                <div class="col-lg-12 d-flex d-flex justify-content-center">
                  <base-pagination :page-object="searchCircularAttachmentPagination"
                                   @settingPage="setPageCircularAttachment"></base-pagination>
                </div>
              </div>

            </div>
            <div class="modal-footer">
              <!--              <button type="button" class="btn btn-secondary btn-sm px-3 font-weight-normal" data-dismiss="modal">Close</button>-->
              <!--              <button type="button" class="btn btn-primary btn-sm px-3 font-weight-normal">Save changes</button>-->
            </div>
          </div>
        </div>
      </div>

      <div>
        <custom-tree-table :items="circulars" :loading="loading" @confirmedDeleteCircular="getCirculars(searchParams)"
                           @confirmUpdateCircular="getCirculars(searchParams)">
        </custom-tree-table>
      </div>
      <div class="d-flex justify-content-center">
        <base-pagination :page-object="crewPagination" @settingPage="setPage"></base-pagination>
      </div>

      <base-modal id="upload-modal" :title="'UPLOAD '+ selected_circular_issue.name" size="lg"
                  @resetField="resetUpload">
        <template #modal-form>
          <div class="modal-body">
            <form @submit.prevent="verifyAddCircular">
              <div class="form-group row">
                <label class="col-2 col-form-label text-left" for="subject">Subject</label>
                <div class="col-10">
                  <input id="subject" v-model="uploadForm.subject" required
                         class="form-control"
                         placeholder="Subject"
                         type="text">
                </div>
              </div>
              <div class="form-group row">
                <label class="col-2 col-form-label text-left" for="subject">Category</label>
                <div class="col-10">
                  <custom-select
                      v-model="uploadForm.circular_category_id"
                      :items="circular_categories"
                      children="sub_categories"
                      selection-display="Category"
                      :required="true"
                  ></custom-select>
                </div>
              </div>
              <div class="form-group row d-none" v-show="authUser.position === 'SYSTEM ADMIN'">
                <label class="col-2 col-form-label text-left" for="subject">Circular</label>
                <div class="col-10">
                  <!--                  <input-->
                  <!--                      :value="selectedCircular"-->
                  <!--                      class="form-control form-control-sm text-left bg-white" data-target="#select-circular-list"-->
                  <!--                      data-toggle="modal"-->
                  <!--                      readonly type="button"-->
                  <!--                  >-->

                  <input
                      :value="uploadForm.subject"
                      class="form-control form-control-sm text-left bg-white"
                      readonly type="button"
                  >
                  <!--                  <div class="col-10 text-left">-->
                  <!--                  <p style="word-wrap: break-word">{{ uploadForm.subject }}</p>-->
                  <!--                  </div>-->

                </div>
              </div>

              <div class="form-group row">
                <label class="col-2 col-form-label text-left" for="new-circular-date">Date</label>
                <div class="col-10">
                  <input id="date" v-model="uploadForm.date" class="form-control" name="date" required type="date">
                </div>
              </div>
              <div class="form-group row">
                <label class="col-2 col-form-label text-left" for="attachment">Choose File</label>
                <div class="col-10">
                  <input id="attachment" ref="circular_attachment"
                        :accept="[
                          '.doc',
                          '.docx',
                          'application/msword',
                          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                          'application/pdf',
                          '.xls',
                          '.xlsx',
                          'application/vnd.ms-excel',
                          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                          'application/vnd.ms-excel.sheet.macroEnabled.12',
                          'application/vnd.sealed.eml',
                          'message/rfc822',
                          'application/octet-stream',
                          '.zip',
                          'application/zip',
                          'application/x-zip-compressed',
                          'image/apng',
                          'image/avif',
                          'image/gif',
                          'image/jpeg',
                          'image/png',
                          'image/svg+xml',
                          'image/webp',
                          'application/vnd.ms-powerpoint',
                          'application/vnd.openxmlformats-officedocument.presentationml.presentation',
                        ].join(',')"
                         class="form-control" name="attachment"
                         type="file"
                         @change="changeAttachment">
                </div>
              </div>

              <div class="modal-footer">
                <button class="btn btn-success" type="submit">
                  <font-awesome-icon icon="save"></font-awesome-icon>
                  Save
                </button>
              </div>
            </form>

          </div>
        </template>
      </base-modal>
      <base-modal id="select-circular-list" :title="'SELECT '+selected_circular_issue.name" size="xl"
                  @resetField="resetUploadCircularModal">
        <template #modal-form>
          <select-circular
              :circular-category-id="uploadForm.circular_category_id"
              :circular-issue-id="uploadForm.circular_issue_id"
              @setSelected="setSelectedCircular">
          </select-circular>
        </template>
      </base-modal>
    </div>
  </div>
</template>
<script>
import TreeNav from '@/components/TreeNav';
import {mapActions, mapGetters, mapMutations} from 'vuex';
import CustomTreeTable from '@/components/CustomTreeTable';
import BaseModal from '@/components/base/BaseModal';
import CustomSelect from '@/components/CustomSelect';
import {AlertService} from '@/service/alert.service';
import {AppService} from '@/service/app.service';
import SelectCircular from '@/components/SelectCircular';
import {UacMixins} from "@/mixins/uac.mixins";
import {AppMixins} from "@/mixins/app.mixins";
import {FileService} from "@/service/file.service";
import axios from "axios";

export default {
  components: {TreeNav, CustomTreeTable, BaseModal, CustomSelect, SelectCircular},
  mixins: [UacMixins, AppMixins],
  data() {
    return {
      searchBySelection: 'attachment',
      smsLetter: [
        {
          name: 'SMS A',
          letter: 'A',
        },

        {
          name: 'SMS B',
          letter: 'B',
        },

        {
          name: 'SMS C',
          letter: 'C',
        },

        {
          name: 'SMS D',
          letter: 'D',
        },

        {
          name: 'SMS E',
          letter: 'E',
        },

        {
          name: 'SMS F',
          letter: 'F',
        },

        {
          name: 'SMS G',
          letter: 'G',
        },

        {
          name: 'SMS H',
          letter: 'H',
        },

        {
          name: 'SMS I',
          letter: 'I',
        },

        {
          name: 'SMS J',
          letter: 'J',
        },

        {
          name: 'SMS K',
          letter: 'K',
        },

        {
          name: 'SMS L',
          letter: 'L',
        },

        {
          name: 'SMS M',
          letter: 'M',
        },
        {
          name: 'SMS N',
          letter: 'N',
        },
        {
          name: 'SMS O',
          letter: 'O',
        },

        {
          name: 'SMS P',
          letter: 'P',
        },

        {
          name: 'SMS Q',
          letter: 'Q',
        },

        {
          name: 'SMS R',
          letter: 'R',
        },

        {
          name: 'SMS S',
          letter: 'S',
        },

        {
          name: 'SMS T',
          letter: 'T',
        },

        {
          name: 'SMS U',
          letter: 'U',
        },

        {
          name: 'SMS V',
          letter: 'V',
        },

        {
          name: 'SMS W',
          letter: 'W',
        },

        {
          name: 'SMS X',
          letter: 'X',
        },
        {
          name: 'SMS Y',
          letter: 'Y',
        },

        {
          name: 'SMS Z',
          letter: 'Z',
        },


      ],

      searchAttachmentParam: {
        searchValue: null,
        count: 10,
        page: 1,
      },

      // sampleSearchAttachmentParams: {
      //   searchValue: 12233,
      // },

      isDownloading: false,
      onSearching: null,

      searchCircularAttachmentParams: {
        searchValue: null,
        count: 10,
        page: 1,
      },

      searchParams: {
        page: 1,
        circular_category_id: '',
        circular_issue_id: '',
        search: '',
        letter_number: '',
        filterSubj: '',
      },

      searchParamsFilterSMS: {
        filterSubj: '',
      },

      getCircularSubjectParams: {
        circular_category_id: 28,
        subject: 'SMS',
      },

      uploadForm: {
        circular_issue_id: null,
        circular_category_id: null,
        parent_id: null,
        subject: null,
        date: null,
      },
      selectedCircular: '',
      loading: false,
      attachment: '',
      circularCategory: null,

      tempValForMakuhari: {
        id: 3, name: 'MAKUHARI',
      },

      archiveIndexPosition: 0,
      showArchiveNavTab: false,

    };
  },
  computed: {
    ...mapGetters([
      'circular_issues',
      'circular_issues_archive',
      'selected_circular_issue',
      'selectedCategory',
      'circular_categories',
      'circulars',
      'crewPagination',
      'authUser',
      'circularAttachments',
      'searchCircularAttachmentPagination',

      'circularSubjects',
      'isLoading',
    ]),


    searchValue: {
      get() {
        return this.searchAttachmentParam.searchValue;
      },

      set(val) {
        this.searchAttachmentParam.searchValue = val;
      }
    },

    searchingFor() {

      if (this.searchAttachmentParam.searchValue && this.onSearching == null) {
        return this.searchAttachmentParam.searchValue;
      }

      // if (this.onSearching != null) {
      //   return this.onSearching;
      // }


    },
  },

  async created() {
    await this.getCircularIssues();
    await this.getCircularIssuesArchive();
    await this.setCircularCategories();
    await this.getCircularSubjects(this.getCircularSubjectParams);
    await this.$nextTick(() => {
      this.updateParams();
    });
    this.paginateWatch = _.debounce(this.setToOne, 750);
  },
  watch: {
    'searchParams.search'() {
      this.searchParams.letter_number = ""
      this.paginateWatch();
    },
    'searchParams.letter_number'() {
      this.searchParams.search = ""
      this.paginateWatch();
    },

    'searchParams.filterSubj'() {
      this.paginateWatch();

      if (this.searchParams.filterSubj) {
        this.searchParams.search = '';
      }
    },

    'selected_circular_issue'(){
        this.searchParams.filterSubj = '';
        this.searchParams.search = '';
    }

  },

  methods: {
    ...mapActions([
      'getCircularIssues',
      'getCircularIssuesArchive',
      'getCircularCategory',
      'getCirculars',
      'addCircular',
      'searchCrewAttachment',
      'getCircularFileAttachmentOnSearch',
      'getCircularSubjects',
    ]),

    ...mapMutations([
      'SET_SELECTED_ISSUE',
      'SET_SELECTED_CIRCULAR_CATEGORY',
      'SET_CIRCULARS_FOR_SELECTION',
    ]),

    async changeCircularIssue(issue) {
      this.showArchiveNavTab = false;
      await this.SET_SELECTED_ISSUE(issue);
      await this.SET_SELECTED_CIRCULAR_CATEGORY({});
      this.searchParams.circular_category_id = null;
      await this.setCircularCategories();
      await this.setToOne();

    },

    async changeCircularIssueArchive(issue) {
      this.showArchiveNavTab = true;
      this.searchParams.filterSubj = '';
      this.searchParams.search = '';

      await this.SET_SELECTED_ISSUE(issue);
      await this.SET_SELECTED_CIRCULAR_CATEGORY({});
      this.searchParams.circular_category_id = null;
      await this.setCircularCategories();
      await this.setToOne();

      this.archiveIndexPosition = this.circular_issues_archive.findIndex(x => x.id === issue.id);


    },

    resetUpload() {
      this.uploadForm = Object.assign({}, {
        circular_issue_id: this.selected_circular_issue.id,
        circular_category_id: null,
        parent_id: null,
        subject: null,
        date: null,
      });
      this.attachment = '';
      this.$refs.circular_attachment.value = null;

      this.selectedCircular = null;
      this.SET_CIRCULARS_FOR_SELECTION([]);
    },

    resetUploadCircularModal() {
      this.uploadForm.parent_id = null;
      this.selectedCircular = null;
      this.SET_CIRCULARS_FOR_SELECTION([]);
    },

    setCircularCategorySearch(category) {
      this.searchParams.circular_category_id = category.id;
      this.circularCategory = category;
      this.SET_SELECTED_CIRCULAR_CATEGORY(category);
      this.setToOne();
    },
    async setCircularCategories() {
      if (this.selected_circular_issue) {
        await this.getCircularCategory(this.selected_circular_issue.id);
      }
    },
    async updateParams() {
      this.loading = true;
      this.searchParams.circular_issue_id = this.selected_circular_issue.id;
      this.uploadForm.circular_issue_id = this.selected_circular_issue.id;
      await this.getCirculars(this.searchParams);
      this.loading = false;
    },
    setSelectedCircular(circular) {
      this.uploadForm.parent_id = circular.id;
      this.selectedCircular = circular.subject;
      $('#select-circular-list').modal('hide');
    },
    changeAttachment(event) {
      this.attachment = event.target.files[0];
    },
    async setToOne() {
      await this.setPage(1);
    },
    async setPage(e) {
      this.searchParams.page = e;
      await this.updateParams();
    },

    async verifyAddCircular() {
      if (
          await AlertService.questionAlertService('Do you want to Add ?', 'ADD CIRCULAR', 'question')
      ) {
        let form = AppService.generateFormData(this.uploadForm, this.attachment);
        let response = await this.addCircular(form);
        if (!response.errors) {
          this.resetUpload();
          AlertService.successAlertService('Circular has been added', 'ADD CIRCULAR');
          $('#upload-modal').modal('hide');
        }
      }
    },

    show_circular_attachments_modal() {
      this.searchCrewAttachment(this.searchAttachmentParam);
      // console.log('show_circular_attachments_modal')
      // $('#searchCircularAttachmentModal').modal('show');
      // console.log('get_circular_attachments')
    },


    reset_search_circular_attachment() {
      this.onSearching = null;
      this.searchAttachmentParam.searchValue = null
      this.searchAttachmentParam.page = null
    },

    setPageCircularAttachment(e) {
      this.searchAttachmentParam.page = e;
      // this.userPagination.currentPage = e;
      this.updateCircularAttachmentParams();
    },

    async updateCircularAttachmentParams() {
      await this.searchCrewAttachment(this.searchAttachmentParam);
    },

    async viewAttachmentFileOnSearch(circularId, circularAttachmentId) {
      let params = {
        circularId: circularId ? circularId : '',
        circularAttachmentId: circularAttachmentId ? circularAttachmentId : '',
      }
      let response = await this.getCircularFileAttachmentOnSearch(params);
      if (!response.errors) {
        FileService.viewDocument(response.file, 'dasdasasd');
      }
    },
    async downloadAll() {
      this.isDownloading = true

      swal.fire({
        title: "Downloading...",
        text: "Please wait while the file is being downloaded.",
        allowOutsideClick: false,
        didOpen: () => {
          swal.showLoading();
        },
      })

      const response = await axios({
        method: 'get',
        url: '/crew/circulars-download',
        params: {
          "circular_issue_id" : this.searchParams.circular_issue_id,
          "subject" :this.searchParams.filterSubj ?? ""
        },
        responseType: 'blob',
      })

      const blob = new Blob([response.data], { type: 'application/zip' })

      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob);
      link.download = `SMS_Memo_${new Date().toISOString().replace(/[:\-T.]/g, '').slice(0, 15)}.zip`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      swal.fire({
        title: "Download Complete",
        text: "The ZIP file has been downloaded successfully.",
        icon: "success",
      });

      this.isDownloading = false
    }
  },


  mounted() {
    $(document).ready(function () {
      $('a[data-toggle="tab"]').on('show.bs.tab', function (e) {
        localStorage.setItem('activeTab', $(e.target).attr('href'));
      });
      let activeTab = localStorage.getItem('activeTab');
      if (activeTab) {
        $('#myTab a[href="' + activeTab + '"]').tab('show');
        $('#myTab2 a[href="' + activeTab + '"]').tab('show');
      }
    });

    // $(document).ready(function () {
    //   $('a[data-toggle="tab"]').on('show.bs.tab', function (e) {
    //     localStorage.setItem('activeTab', $(e.target).attr('href'));
    //   });
    //   let activeTab = localStorage.getItem('activeTab');
    //   if (activeTab) {
    //     $('#myTab2 a[href="' + activeTab + '"]').tab('show');
    //   }
    // });

    $('#search-value').unbind("keyup").keyup(function (e) {
      let code = e.which;
      if (code == 13) $("#btn-search").click();
    });

  },

};
</script>

<style scoped>
.nav-pills .nav-link {
  color: #555;
}

.nav-pills > li > a.active {
  background-color: #343a40;
  color: white;
}


.addScroll {
  overflow-y: auto;
  /*height: 700px;*/
}


</style>
